import { Component, OnInit } from '@angular/core';
import { QueryInterface } from 'app/shared/common/parse/query-interface';
import { ParseService } from 'app/shared/common/parse/parse.service';
import { ActivatedRoute } from '@angular/router';
import { FormGroup, FormBuilder } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { StorageConfiguration } from 'app/shared/common/storage-setting/storage-configuration';
import { HardCodedValues } from 'app/shared/common/hard-coded-values';
import { ActivityCenterService } from 'app/shared/common/helper/activity-center';

@Component({
  selector: 'app-comments',
  templateUrl: './comments.component.html',
  styleUrls: ['./comments.component.scss']
})

export class CommentsComponent implements OnInit {

  empRole = '';
  commentData = [];
  objectId = '';
  isEdit: boolean;
  commentsForm: FormGroup;
  commentsFormErrors: { comments: {}; };
  firstname: String;
  lastname: String;
  newDate = Date.now();
  show: boolean = true;
  projectId: any;
  noData = false;
  currentStatus: any;
  projectTypeCheck: any;
  currentUser: any;

  constructor(
    private queryInterface: QueryInterface,
    private parseService: ParseService,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private toastr: ToastrService,
    private storageConfiguration: StorageConfiguration,
    private hardCodedValues: HardCodedValues,
    private activityCenterService: ActivityCenterService

  ) {
    this.firstname = this.parseService.instance.User.current().get('firstName');
    this.lastname = this.parseService.instance.User.current().get('lastName');
    this.currentUser = this.parseService.instance.User.current();

    this.commentsForm = this.formBuilder.group({
      comments: [''],
    });
    this.commentsFormErrors = {
      comments: {}
    };
  }

  /*
  ** ==========================================================
  ** On Init
  ** ==========================================================
  */
  async ngOnInit() {
    this.empRole = this.storageConfiguration.sessionGetItem(this.storageConfiguration.role);
    this.route.params.subscribe(params => {
      this.objectId = params['id'];
      if (this.objectId != '' && this.objectId != undefined) {
        this.isEdit = true;
      }
    });
    let condition = [{ condition: 'equalTo', field: 'objectId', value: this.objectId }];
    await this.queryInterface.executeQuery(this.parseService, 'Project', condition).then(results => {
      let result = results[0];
      let projectInfo = result.get('projectInfo').currentStatus;
      this.currentStatus = projectInfo;
      this.projectTypeCheck = result.get('projectType');
    });

    this.getComments();
    if (this.empRole == "Leader") {
      this.getLeadersProjectId();
    }
  }

  /*
  ** ==========================================================
  ** Get Comments
  ** ==========================================================
  */
  getComments() {
    if (this.empRole == 'Admin') {
      this.queryInterface.executeQuery(this.parseService, 'Project', [{ condition: 'equalTo', field: 'objectId', value: this.objectId }]).then(result => {
        let results = result[0];
        this.commentData = results.get('comments');
      });
    }
    else if (this.empRole == 'Leader' || this.empRole == 'Employee') {
      this.queryInterface.executeQuery(this.parseService, 'ProjectMembers',
        [
          { condition: 'include', value: 'client' },
          { condition: 'include', value: 'project' },
          { condition: 'include', value: 'project.client' },
          { condition: 'include', value: 'user' },
          { condition: 'equalTo', field: 'project', value: { __type: 'Pointer', className: 'Project', objectId: this.objectId } }]).then(results => {
            let result = results[0];
            this.commentData = result.get('project').get('comments');
          });
    }
    if (this.commentData == []) {
      this.noData = true;
    }
  }

  /*
  ** ==========================================================
  ** Add New Comments
  ** ==========================================================
  */
  addComment() {
    const createrProfile = this.currentUser.get('profile');
    const createrImg = createrProfile.get('profileImageInfo').url;

    let commentValue = this.commentsForm.value.comments;
    if (commentValue != '' && commentValue != undefined) {
      this.commentData.unshift({
        name: this.firstname.concat(' ' + this.lastname),
        comment: commentValue,
        date: this.newDate,
        createrImgUrl: createrImg == undefined ? this.hardCodedValues.defaultProfileImg : createrImg
      });

      let activities = [];
      let message = 'Added a comment';
      let activity = this.activityCenterService.setActivityModel(message);
      activities.push(activity);

      if (this.empRole == 'Admin') {
        this.queryInterface.executeQuery(this.parseService, "Project", [
          { condition: "equalTo", field: "objectId", value: this.objectId }]).then(result => {
            let results = result[0];
            results.set("comments", this.commentData);
            this.toastr.success('Comments Saved Successfully');
            results.save().then(res => {

              if (this.projectTypeCheck == 'Project') {
                this.activityCenterService.createActivity(activities, this.hardCodedValues.project, this.objectId);
              }
              else if (this.projectTypeCheck == 'Sub-Project') {
                this.activityCenterService.createActivity(activities, this.hardCodedValues.addons, this.objectId);
              }

            });
          });
      }
      else if (this.empRole == 'Leader' || this.empRole == 'Employee') {
        this.queryInterface.executeQuery(this.parseService, "Project", [
          { condition: "equalTo", field: "objectId", value: this.objectId }]).then(result => {
            let results = result[0];
            results.set("comments", this.commentData)
            this.toastr.success('Comments Saved Successfully');
            results.save().then(res => {

              if (this.projectTypeCheck == 'Project') {
                this.activityCenterService.createActivity(activities, this.hardCodedValues.project, this.objectId);
              }
              else if (this.projectTypeCheck == 'Sub-Project') {
                this.activityCenterService.createActivity(activities, this.hardCodedValues.addons, this.objectId);
              }

            });
          });
      }
    }
    else {
      this.toastr.error('Add comments');
    }

    this.commentsForm.patchValue({
      comments: ''
    });
  }

  getLeadersProjectId() {
    if (this.empRole == "Leader") {
      this.queryInterface.executeQuery(this.parseService, 'ProjectMembers',
        [
          { condition: 'include', value: 'client' },
          { condition: 'include', value: 'project' },
          { condition: 'include', value: 'project.client' },
          { condition: 'include', value: 'user' },
          { condition: 'equalTo', field: 'project', value: { __type: 'Pointer', className: 'Project', objectId: this.objectId } }]).then(results => {
            let result = results[0];
            let Finalres = result.get('project')
            this.projectId = Finalres.id;
          }
          );
    }
  }


}
